import type { BrandedIdentifier } from '../brandedIdentifier';

export type ExerciseId = BrandedIdentifier<'Exercise', string | number>;

export const toExerciseId = (value: string | number): ExerciseId => value as ExerciseId;
